var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-team': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"color":"#fff","color2":"#fff","title":_vm.titleString,"subtitle":_vm.subtitleString}}),_vm._v(" "),_c('AtomsCommonAtomVerticalLine')],1),_vm._v(" "),(_vm.teamData.length)?_c('OrganismsPortfolioOrganismTeam',{attrs:{"team-data":_vm.teamData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }